import {
  Badge,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { TBasicListItem } from '../../../utils/types/layoutTypes'
import { useNavigate } from 'react-router-dom'
import { useSupportCounterContext } from '../../../context/supportCounterContext/SupportCounterContextProvider'
import { useAuthContext } from '../../../context/auth/AuthContextProvider'

const SupportMenuList = ({
  index,
  selected,
  listItem,
  navMenuOpen,
}: TBasicListItem) => {
  const { user } = useAuthContext()
  const navigate = useNavigate()
  const { supportCounter } = useSupportCounterContext()

  const iconMinWidth = user.companyOptions.includes('MENU_JOBS_STATUS')
    ? '40px'
    : '56px'

  return (
    <Tooltip
      key={index}
      title={`${navMenuOpen ? '' : listItem.label}`}
      placement="right"
    >
      <ListItemButton
        selected={selected}
        onClick={() => navigate(listItem.goToUrl)}
      >
        <ListItemIcon sx={{ color: 'var(--white)', minWidth: iconMinWidth }}>
          {supportCounter > 0 ? (
            <Badge color="secondary" badgeContent={supportCounter} max={9}>
              {listItem.icon}
            </Badge>
          ) : (
            listItem.icon
          )}
        </ListItemIcon>

        <ListItemText primary={listItem.label} />
      </ListItemButton>
    </Tooltip>
  )
}

export default SupportMenuList
